import React from "react";
import styled from "styled-components";
import White from "../white";
import Container from "../container";
import Portable2 from "../portable2";
import ButtonWhite from "../button_white";
import ButtonDisabled from "../button_disabled";

const Wrapper = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  h2 {
    margin-bottom: 66px;
    @media (max-width: 768px) {
      margin-bottom: 25px;
    }
    &.centered {
      margin-bottom: 73px;
      text-align: center;
      @media (max-width: 768px) {
        margin-bottom: 25px;
      }
    }
  }
  img {
    margin-bottom: 73px;
    border-radius: 20px;
    @media (max-width: 768px) {
      margin-bottom: 25px;
      border-radius: 17px;
    }
  }
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  h2 {
    margin-top: 73px;
    margin-left: 0;
    margin-bottom: 66px;
  }
  h3 {
    margin-top: 43px;
    margin-bottom: 17px;
  }
  &.cta {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 20px;
    padding-top: 20px;
  }
  &.cta h3 {
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0;
  }
  ul, ol {
    li {
      font-size: 22px;
      line-height: 32px;
      margin-bottom: 1rem;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
`;

const Col = styled.div`
  h3 {
    margin-left: 0;
  }
  @media (max-width: 768px) {
    p {
      margin-bottom: 1rem;
    }
  }
`;

const Center = styled.div`
  text-align: center;
  width: 100%;
  margin-top: 150px;
`;

const Column1 = (props) => {
  const { module } = props;


  function removeLeadingSlash(inputString) {
    // Check if the string starts with a forward slash
    if (inputString.startsWith("/")) {
      // If yes, remove the leading slash and return the modified string
      return inputString.substring(1);
    } else {
      // If no leading slash, return the original string
      return inputString;
    }
  }

  return (
    <White borderbottom={module?.underline ? true : false} className="col1">
      <Container>
        <Wrapper className="prose">
          {module.heading && (
            <h2 className={module?.centered ? "centered" : ""}>
              {module.heading}
            </h2>
          )}
          {module.image && <img src={module.image.asset.publicUrl} />}
          <Row>
            <Col>
              <Portable2 value={module._rawBody} />
              <br />
            </Col>
          </Row>
          <Row className="cta">
            {module.cta_text && module.cta_link && (
              <ButtonWhite
              link={
                module.cta_link.includes("https")
                  ? module.cta_link
                  : `/${module.cta_link}`
              }
            >
              {module.cta_text}
            </ButtonWhite>
            )}
            {module.cta_text && module.cta_link === null && (
              <ButtonDisabled>{module.cta_text}</ButtonDisabled>
            )}
          </Row>
        </Wrapper>
      </Container>
    </White>
  );
};

export default Column1;
